import { useLocation, useMatches } from 'react-router';

const PRODUCT_ROUTE_ID = 'routes/_app.product.$urlSegment';

interface ProductRouteRevampFlags {
    detailsRevamp?: boolean;
}

/**
 * True when the current page is the product detail revamp, which renders the
 * warning banner in the page flow (above the top nav) instead of the header's
 * own instance. Derived from route matches + loader flags (mirroring
 * ProductPage's showRevamp) so server and client render identically — an
 * effect-set atom here caused the banner to jump position after hydration.
 */
export const useInlineWarningBanner = (): boolean => {
    const matches = useMatches();
    const location = useLocation();

    const productMatch = matches.find((match) => match.id === PRODUCT_ROUTE_ID);
    if (!productMatch?.data) return false;

    const { detailsRevamp } = productMatch.data as ProductRouteRevampFlags;
    const searchParams = new URLSearchParams(location.search);
    return Boolean(
        detailsRevamp ||
        (import.meta.env.DEV &&
            (searchParams.get('revamp') === '1' ||
                searchParams.get('detailsRevamp') === '1')),
    );
};
